const SELECTED_PATIENT_STORAGE_KEY = "selectedPatientProfile";

function canUseSessionStorage() {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

export function readStoredSelectedPatient() {
  if (!canUseSessionStorage()) {
    return null;
  }

  try {
    const rawValue = window.sessionStorage.getItem(SELECTED_PATIENT_STORAGE_KEY);

    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);

    if (!parsedValue || typeof parsedValue !== "object") {
      return null;
    }

    return parsedValue;
  } catch (error) {
    return null;
  }
}

export function writeStoredSelectedPatient(patient) {
  if (!canUseSessionStorage()) {
    return;
  }

  if (!patient || (!patient.subjectKey && !patient.sid && !patient.uid)) {
    window.sessionStorage.removeItem(SELECTED_PATIENT_STORAGE_KEY);
    return;
  }

  const safePatient = {
    subjectKey: patient.subjectKey || null,
    sid: patient.sid || null,
    uid: patient.uid || null,
    uids: Array.isArray(patient.uids) ? patient.uids : [],
    clinicStudyId: patient.clinicStudyId || null,
    email: patient.email || null,
    emails: Array.isArray(patient.emails) ? patient.emails : [],
    measurementsCount:
      typeof patient.measurementsCount === "number"
        ? patient.measurementsCount
        : null,
    lastMeasurementAt: patient.lastMeasurementAt || null,
  };

  window.sessionStorage.setItem(
    SELECTED_PATIENT_STORAGE_KEY,
    JSON.stringify(safePatient),
  );
}

export function clearStoredSelectedPatient() {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(SELECTED_PATIENT_STORAGE_KEY);
}

export function buildSelectedPatientKey(patient) {
  const subjectKey =
    typeof patient?.subjectKey === "string" ? patient.subjectKey.trim() : "";

  if (subjectKey) {
    return `subject:${subjectKey}`;
  }

  const clinicStudyId =
    typeof patient?.clinicStudyId === "string"
      ? patient.clinicStudyId.trim()
      : "";
  const sid = typeof patient?.sid === "string" ? patient.sid.trim() : "";

  if (sid && sid.toUpperCase() !== "N/A") {
    return clinicStudyId ? `study:${clinicStudyId}:sid:${sid}` : `sid:${sid}`;
  }

  const uid = typeof patient?.uid === "string" ? patient.uid.trim() : "";

  return uid ? `uid:${uid}` : "";
}

export function buildPatientProfileHref(patient) {
  const subjectKey =
    typeof patient?.subjectKey === "string" ? patient.subjectKey.trim() : "";
  const sid = typeof patient?.sid === "string" ? patient.sid.trim() : "";
  const searchParams = new URLSearchParams();

  if (subjectKey) {
    searchParams.set("subjectKey", subjectKey);

    if (sid && sid.toUpperCase() !== "N/A") {
      searchParams.set("sid", sid);
    }

    return `/patients/profile?${searchParams.toString()}`;
  }

  if (sid && sid.toUpperCase() !== "N/A") {
    return `/patients/profile?sid=${encodeURIComponent(sid)}`;
  }

  return "/patients/profile";
}
